import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Site-wide footer: brand, data attribution, and the legal/info links every
 * production site needs (About · Terms · Privacy · Contact).
 *
 * `attribution` lets a page swap the data-source line (e.g. manhua vs film).
 */
const Footer = ({ attribution }) => (
  <footer style={{ borderTop: '1px solid rgba(241,236,226,0.08)' }}>
    <div className="mx-auto px-6 sm:px-10 py-10" style={{ maxWidth: 1440 }}>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <Link to="/" className="font-serif text-binge-ink" style={{ fontSize: 18 }}>
            What to Binge
          </Link>
          <p className="mt-1 text-binge-faint" style={{ fontSize: 13 }}>
            {attribution || 'Film & series data from The Movie Database (TMDB)'}
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-5 gap-y-2" style={{ fontSize: 13 }}>
          <Link to="/about" className="text-binge-sub hover:text-binge-ink transition-colors">About</Link>
          <Link to="/terms" className="text-binge-sub hover:text-binge-ink transition-colors">Terms</Link>
          <Link to="/privacy" className="text-binge-sub hover:text-binge-ink transition-colors">Privacy</Link>
          <Link to="/contact" className="text-binge-sub hover:text-binge-ink transition-colors">Contact</Link>
          <Link to="/methodology" className="text-binge-sub hover:text-binge-ink transition-colors">Methodology</Link>
        </nav>
      </div>

      <p className="mt-6 text-binge-faint" style={{ fontSize: 12, lineHeight: 1.6 }}>
        © {new Date().getFullYear()} What to Binge. A discovery tool — we don’t host
        or stream any content. Not affiliated with, endorsed by, or certified by
        any streaming service, TMDB, MangaDex, or AniList. All titles, posters and
        trademarks belong to their respective owners.
      </p>
    </div>
  </footer>
);

export default Footer;
